// Polyfill crypto.subtle for insecure contexts (must be first import!)
import "./utils/cryptoPolyfill";

import React from "react";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import App from "./App";
import { LoadingSpinner } from "./components/common/LoadingSpinner";
import { authConfig } from "./config/auth";
import { NotificationProvider } from "./contexts";
import { store, persistor } from "./store";
import { theme } from "./theme";
import { AuthProvider as CustomAuthProvider } from "./utils/authProvider";

import "./styles/global.scss";
import "./index.css";
import "normalize.css";

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // Disable automatic retries globally
      refetchOnWindowFocus: false,
      refetchOnMount: false, // Prevent refetch on component mount
      refetchOnReconnect: false, // Prevent refetch on network reconnect
    },
    mutations: {
      retry: 0,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<LoadingSpinner />} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <NotificationProvider>
              <AuthProvider {...authConfig}>
                <CustomAuthProvider>
                  <App />
                </CustomAuthProvider>
              </AuthProvider>
            </NotificationProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
